

export const onReady = (callback: () => void) => {
    if (document.readyState === `loading`) {
        document.addEventListener(`DOMContentLoaded`, callback, { once: true });
    }
    else {
        callback();
    }
};
